import axios from 'axios';

const UseAxiosSecure = () => {
  const axiosSecure = axios.create({
    baseURL:  'https://jilapi.net/api',
    // baseURL: 'http://localhost:8080/api',
  });

  // Add a request interceptor
  axiosSecure.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token');
    const branchId = localStorage.getItem('activeBranchId'); // 👈 NEW: Get branch ID

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // 👈 NEW: Attach branch ID to headers if it exists
    if (branchId) {
      config.headers['x-branch-id'] = branchId; 
    }

    return config;
  }, function (error) {
    return Promise.reject(error);
  });

  // Add a response interceptor
  axiosSecure.interceptors.response.use(function onFulfilled(response) {
    return response;
  }, function onRejected(error) {
    return Promise.reject(error);
  });

  return axiosSecure;
};

export default UseAxiosSecure;